import { render, staticRenderFns } from "./ResumationSwitch.vue?vue&type=template&id=1b73c4fb&"
import script from "./ResumationSwitch.vue?vue&type=script&lang=js&"
export * from "./ResumationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports